import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import DashboardWillMount from "../../../Middleware/Middlewares/DashboardWillMount";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { ConversationInterface } from "../../../Entity/Entities/Conversation/ConversationInterface";
import { TabsComponent } from "./TabsComponent";
import Card from '@material-ui/core/Card';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Constants from "../../../Action/Constants";

class Messages extends Component {
  protected middlewares: MiddlewareInterface[] = [
    DashboardWillMount
  ];
  protected selectedConversation: ConversationInterface;
  protected selectedConversationIndex: number;

  public state = {
    // filter: this.props.app?.messagesFilterState,
    // filterValue: this.props.app?.messagesFilterSearchState,
    includeClosed: false,
    createdByMe: false,
    conversations: this.props.app.conversations,
    anchorEl: null,
  };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (!this.props?.events?.requestsOutdated && nextProps?.events?.requestsOutdated) {
      this.setState({
        conversations: nextProps?.app?.conversations
      }, () => this.getMessages());
      
    }
  }

  protected openMenu = (event: any, conversation: ConversationInterface, index: number): void => {
    this.selectedConversation = conversation;
    this.selectedConversationIndex = index;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.selectedConversation = null;
    this.selectedConversationIndex = null;

    this.setState({
      anchorEl: null,
    })
  }

  public changeCreatedByMeFilter = () => {
    this.setState({
      createdByMe: !this.state.createdByMe
    });

    // this.props.dispatch({
    //   type: Constants.PAGE_TASKS_LIST_CHECK_FILTER,
    //   payload: {
    //     createdByMe: !this.state.createdByMe
    //   }
    // });
  }

  public changeIncludeClosedFilter = () => {
    this.setState({
      includeClosed: !this.state.includeClosed
    });

    // this.props.dispatch({
    //   type: Constants.PAGE_TASKS_LIST_CHECK_FILTER,
    //   payload: {
    //     createdByMe: !this.state.createdByMe
    //   }
    // });
  }

  public unactive(event) {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event,
      },
      onSuccess: () => {
        this.props.dispatch({
          type: Constants.GLOBAL_CONVERSATION_READ_UPDATE_START,
          payload: {
            conversationId:this.props.app.conversations?.find(c=>c.eventId === event.id)?.id
          }
        });

        this.setState({
          conversations: this.props.app.conversations.filter(c => c.event?.id !== event.id)
        })
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public getMessages = () => {
    return this.state.conversations.filter((conversation: ConversationInterface) => {
      //TODO fix hardcoded value
      let res = !conversation?.removed && (conversation?.statusId === 1 || (conversation?.statusId === 2 && conversation?.existsUnreadMessages?.forAgency));

      if (this.state.createdByMe && conversation?.createdBy !== this.props.app?.session?.user?.id) {
        res = false;
      }

      //TODO fix hardcoded value
      if (this.state.includeClosed && conversation?.statusId === 2) {
        res = true;
      }

      return res;
    })
      .sort((conv1: ConversationInterface, conv2: ConversationInterface) => {
        const fieldForSort1 = conv1.updatedAt
        const fieldForSort2 = conv2.updatedAt

        if (fieldForSort1 < fieldForSort2) {
          return 1;
        }

        if (fieldForSort1 > fieldForSort2) {
          return -1;
        }

        return 0;
      })
      .map((conversation: ConversationInterface) => {
        return (
          <TableRow
            hover
            key={`conversation-${conversation.id}`}
            className={`clickable-entity`}
            onClick={() => {
              // TODO fix hardcoded value
              if (conversation?.typeId === 2) {
                return this.redirect(`/app/conversation/update/${conversation?.id}`);
              }

              return this.redirect(`/app/task/update/${conversation?.eventId}`);
            }}
          >
            <TableCell style={{ width: "24px", paddingLeft: "24px", paddingRight: "0px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px" }}>
                <div
                  className={"icon icon-ic-message"}
                  style={{
                    color: "#00BCD4",
                    fontSize: "24"
                  }}
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{ width: "15%" }}>{this.formatter.formatDate(conversation?.createdAt)}</TableCell>
            <TableCell style={{ width: "30%" }}>{conversation?.object?.listDisplayName}</TableCell>
            <TableCell style={{ width: "40%" }}>{conversation?.messages?.[conversation?.messages?.length - 1]?.message}</TableCell>
            <TableCell style={{ width: "15%" }}>
              {
                <div
                  style={{
                    display: "flex", justifyContent: "flex-start", flexWrap: "wrap"
                  }}
                >
                  {
                    conversation?.existsUnreadMessages?.forAgency && (
                      <div style={{ padding: "2px" }}>
                        <div className="list-label creation-type-label green">
                          {this.trans("label-unread")}
                        </div>
                      </div>

                    )
                  }
                  {
                    // TODO fix hardcoded value
                    conversation?.statusId === 2 && (
                      <div style={{ padding: "2px" }}>
                        <div className="list-label creation-type-label">
                          {this.trans("status-closed")}
                        </div>
                      </div>

                    )
                  }
                </div>
              }
            </TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
            </TableCell>
          </TableRow>
        );
      });
  }

  public render() {
    return (
      <div className="state-app">
          <div className={`box box-full component-dashboard has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
            <div className="component-header no-paddings">
              <h1>{this.trans("title-dashboard")}</h1>
              <TabsComponent
                activeTab={1}
                {...this.props}
              />
            </div>

            <div className="component-wrapper no-margin-top">
              <div className="component">
                <Card className="card expiring-contracts">
                  <div className="label-container"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      height: "48px",
                      maxHeight: "48px"
                    }}
                  >
                    <h3 className="card-title">
                      {this.trans("title-messages")}
                    </h3>
                  </div>
                  <div>
                    <div>
                      <div
                        className="list-filters-wrapper"
                      >
                        <div style={{ display: "flex" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.includeClosed}
                                onChange={this.changeIncludeClosedFilter}
                                color="primary"
                              />
                            }
                            label={this.trans("include-closed-messages")}
                          />

                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.createdByMe}
                                onChange={this.changeCreatedByMeFilter}
                                color="primary"
                              />
                            }
                            label={this.trans("created-by-me")}
                          />
                        </div>
                      </div>
                    </div>
                    <TableComponent
                      {...this.props}
                      paginator={{
                        name: "DashboardMessages",
                        path: this.props.app.paginator
                      }}
                      headers={[
                        "", this.trans("created"), this.trans("object"), this.trans("message"), ""
                      ]}
                      rows={this.getMessages()}
                      entities={this.props.app.conversations}
                      className="listing-table tasks-listing-table with-first-border not-3-dot"
                      subtitle={this.trans("title-no-messages-to-list")}
                    />
                  </div>
                </Card>
              </div>
            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    units: state.units,
    events: state.events,
    tasks: state.tasks,
    component: state.expiringContracts,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(Messages);
